import { supabase } from '../supabaseClient';

export const apsisService = {
  async getSettings(editionYear) {
    try {
      const { data: edition } = await supabase
        .from('editions')
        .select('id, year')
        .eq('year', editionYear)
        .single();

      if (!edition) throw new Error(`Edition ${editionYear} not found`);

      const { data: settings, error } = await supabase
        .from('apsis_settings')
        .select('*')
        .eq('edition_id', edition.id)
        .single();

      if (error && error.code !== 'PGRST116') throw error;

      return settings || {
        title: 'Agadir Private Security & Innovation Summit',
        footer_image_url: '',
        footer_pdf_url: '',
        is_visible: true,
        edition_id: edition.id
      };
    } catch (error) {
      console.error('Error getting APSIS settings:', error);
      throw error;
    }
  },

  async updateSettings(settings) {
    try {
      const { id, created_at, updated_at, ...updateData } = settings;
      
      if (id) {
        const { error } = await supabase
          .from('apsis_settings')
          .update({ ...updateData, updated_at: new Date().toISOString() })
          .eq('id', id);
        if (error) throw error;
      } else {
        const { error } = await supabase
          .from('apsis_settings')
          .insert([updateData]);
        if (error) throw error;
      }
    } catch (error) {
      console.error('Error updating APSIS settings:', error);
      throw error;
    }
  },

  async register(registration) {
    try {
      const { error } = await supabase
        .from('apsis_registrations')
        .insert([registration]);
      if (error) throw error;
    } catch (error) {
      console.error('Error registering for APSIS:', error);
      throw error;
    }
  },

  async getRegistrations(editionYear) {
    try {
      const { data: edition } = await supabase
        .from('editions')
        .select('id')
        .eq('year', editionYear)
        .single();

      if (!edition) throw new Error(`Edition ${editionYear} not found`);

      const { data, error } = await supabase
        .from('apsis_registrations')
        .select('*')
        .eq('edition_id', edition.id)
        .order('created_at', { ascending: false });

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error getting APSIS registrations:', error);
      throw error;
    }
  },

  async deleteRegistration(id) {
    try {
      const { error } = await supabase
        .from('apsis_registrations')
        .delete()
        .eq('id', id);
      if (error) throw error;
    } catch (error) {
      console.error('Error deleting APSIS registration:', error);
      throw error;
    }
  }
};
